import React from "react";
import NumberFormat from "react-number-format";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { PadresPTTable } from "../../CierreTurno/components/PadresPTTable";
import { DatosTurnoDetalle } from "./DatosTurnoDetalle";
import { PacasSecadoraDetalle } from "./PacasSecadoraDetalle";
import { SobranteTurnoDetalle } from "./SobranteTurnoDetalle";
import { useDetalleTurnoFinalizado } from "../hooks/useDetalleTurnoFinalizado";

export const DetalleTurnoFinalizadoContent = ({ turnoId, regresar }) => {
    const detalle = useDetalleTurnoFinalizado(turnoId);

    const {
        cargando,
        hayPacasEnSecadora,
        haySobranteTurno,
        totalProduccionAproximada,
    } = detalle;

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <DatosTurnoDetalle turno={detalle.turno} />
                    <PacasSecadoraDetalle detalle={detalle} />
                    <SobranteTurnoDetalle detalle={detalle} />
                    <PadresPTTable
                        cierreTurnoForm={detalle}
                        enlaceTancadasTurno={`/produccion-v2/tancadas-turno/${turnoId}`}
                    />

                    <div className="formulario-fields-column gap-1rem mt-3">
                        <div
                            className="formulario-field horizontal ml-auto"
                            style={{ minWidth: "250px" }}
                        >
                            <label
                                className="text-nowrap"
                                htmlFor="total_produccion"
                            >
                                {hayPacasEnSecadora || haySobranteTurno
                                    ? "Total de producción aprox. (Kg)"
                                    : "Total de producción (Kg)"}
                            </label>
                            <NumberFormat
                                className="form-control"
                                value={totalProduccionAproximada}
                                suffix=" Kg"
                                thousandSeparator=","
                                disabled
                                placeholder="0 kg"
                            />
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-center my-4 gap-1rem">
                        <button
                            className="btn btn-outline-dark"
                            onClick={regresar}
                        >
                            Regresar
                        </button>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
